<template>
  <el-button
    v-if="!hasOneBranch"
    type="default"
    class="th:text-th-white th:hover:bg-th-text-secondary"
    text
    size="default"
    @click="toggle"
  >
    {{ location }}
    <el-icon class="el-icon--right">
      <arrow-up-icon v-if="show" />
      <arrow-down-icon v-else />
    </el-icon>
  </el-button>
</template>

<script>
import { storeToRefs } from 'pinia'
import { useBranchesStore } from '@shared/store/branches'
import { useLocationStore, allBranches } from '@shared/store/location'
import { ArrowUpIcon, ArrowDownIcon } from '@shared/assets/icons'

export default {
  components: {
    ArrowUpIcon,
    ArrowDownIcon
  },
  props: {
    show: {
      type: Boolean,
      required: true
    }
  },
  emits: ['toggle'],
  setup() {
    const branchesStore = useBranchesStore()
    const { branchesCount } = storeToRefs(branchesStore)
    const locationStore = useLocationStore()
    const { currentBranchName } = storeToRefs(locationStore)
    return { branchesCount, locationStore, currentBranchName }
  },
  computed: {
    hasOneBranch() {
      return this.branchesCount === 1
    },
    location() {
      if (!this.currentBranchName) {
        this.locationStore.$reset()
        return this.$t('nav.main.items.location.select_placeholder')
      }

      if (this.currentBranchName === allBranches.label) {
        return this.$t('nav.main.items.location.set_all')
      }

      return this.currentBranchName
    }
  },
  methods: {
    toggle() {
      this.$emit('toggle')
    }
  }
}
</script>
